import {atom} from "recoil";
import {EvaluationListParams} from "../../models/serverModels/permission/WPDangerEvaluation";
import {EquipmentListParams} from "../../models/serverModels/equipment/EQSpecification";

type filterType = {
  range: number;
  departmentUID: number;
  startDate: Date | string | null;
  endDate: Date | string | null;
};

export const dangerEvaluationFilterAtom = atom<EvaluationListParams>({
  key: "dangerEvaluationFilterState",
  default: {
    page: 1,
    rows: 30,
    token: "",
    contents: "",
    departmentUID: -1, // -1 은 전체
    range: 0, // -1 전체, 0 - 내부, 1 - 외부
    startDate: null,
    endDate: null,
  },
});
export const equipmentFilterAtom = atom<EquipmentListParams>({
  key: "equipmentFilterState",
  default: {
    page: 1,
    rows: 30,
    token: "",
    type: -1,
    identifyNumber: "",
    name: "",
    level: "",
    creator: "",
    eqLevel: "",
  },
});
